
/*
 * Get first address component by type
 *
 * @param   {Object} address_components[] - Set of addresses
 * @param   {String} component_type       - Type to retrieve
 * @returns {Object|undefined}            - First address result matching type
 */
var getAddressComponentType, getAlternateAddressFormat;

getAddressComponentType = function(arg, component_type) {
  var address_components;
  address_components = arg.address_components;
  return _.find(address_components, function(arg1) {
    var types;
    types = arg1.types;
    return _.some(types, function(type) {
      return type === component_type;
    });
  });
};


/*
 * Get address name
 *
 * @param   {Object} result                      - Google maps result object
 * @param   {Array}  result.address_components[] - Array with address_components describing result
 * @param   {String} result.formatted_address    - Localized nice name for result
 * @returns {String}
 */

getAlternateAddressFormat = function(result) {
  var address;
  if ((address = getAddressComponentType(result, 'sublocality_level_1')) != null) {
    return address.short_name;
  } else if ((address = getAddressComponentType(result, 'locality')) != null) {
    return address.long_name;
  } else if ((address = getAddressComponentType(result, 'administrative_area_level_1')) != null) {
    return address.short_name;
  } else {
    return result.formatted_address;
  }
};

module.exports = {
  getAddressComponentType: getAddressComponentType,
  getAlternateAddressFormat: getAlternateAddressFormat
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvZ2VuZXJhbC9zcGVjaWFsQWRkcmVzc0NvbXBvbmVudFR5cGUuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL3NyYy9mcm9udGVuZC9oZWxwZXIvZ2VuZXJhbC9zcGVjaWFsQWRkcmVzc0NvbXBvbmVudFR5cGUuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7OztBQUFBLElBQUE7O0FBT0EsdUJBQUEsR0FBMEIsU0FBQyxHQUFELEVBQXVCLGNBQXZCO0FBQ3hCLE1BQUE7RUFEMEIscUJBQUQ7U0FDekIsQ0FBQyxDQUFDLElBQUYsQ0FBTyxrQkFBUCxFQUEyQixTQUFDLElBQUQ7QUFDekIsUUFBQTtJQUQyQixRQUFEO1dBQzFCLENBQUMsQ0FBQyxJQUFGLENBQU8sS0FBUCxFQUFjLFNBQUMsSUFBRDthQUFVLElBQUEsS0FBUTtJQUFsQixDQUFkO0VBRHlCLENBQTNCO0FBRHdCOzs7QUFJMUI7Ozs7Ozs7OztBQVFBLHlCQUFBLEdBQTRCLFNBQUMsTUFBRDtBQUMxQixNQUFBO0VBQUEsSUFBRywwRUFBSDtXQUNFLE9BQU8sQ0FBQyxXQURWO0dBQUEsTUFFSyxJQUFHLCtEQUFIO1dBQ0gsT0FBTyxDQUFDLFVBREw7R0FBQSxNQUVBLElBQUcsa0ZBQUg7V0FDSCxPQUFPLENBQUMsV0FETDtHQUFBLE1BQUE7V0FHSCxNQUFNLENBQUMsa0JBSEo7O0FBTHFCOztBQVU1QixNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNmLHlCQUFBLHVCQURlO0VBRWYsMkJBQUEseUJBRmUifQ==
